import SimilarJobsResultList from "../../jobs/search/SimilarJobsResultList.js";

const LatestJobsCard = (props) => {
  return <SimilarJobsResultList query={[]} currentJobId={null} />;
};

export default LatestJobsCard;
